/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/user';
import { USER } from '@/store/types';
import { UserAtListData } from '@/api/types/user';

export interface StoreUserAtState {
  kw: string;
  kwPending: string;
  matches: Required<UserAtListData>['matches'];
  recents: Required<UserAtListData>['recents'];
  users: Required<UserAtListData>['users'];
}

export default {
  namespaced: true,
  state: {
    kw: null,
    kwPending: null,
    matches: [],
    recents: [],
    users: [],
  },
  getters: {},
  actions: {
    [USER.GET_AT_LIST]({ state, commit }, { kw, reload }) {
      if (state.kw !== kw) {
        reload = true;
      }
      if (state.kwPending === kw) {
        reload = false;
      }
      if (reload) {
        commit(USER.GET_AT_LIST, { status: 'start', kw });
        return new Promise((resolve, reject) => {
          api.getAtList(kw).then((res) => {
            commit(USER.GET_AT_LIST, {
              status: 'success',
              kw,
              ...res.data,
            });
            resolve();
          }).catch(() => {
            commit(USER.GET_AT_LIST, { status: 'failure', kw });
            reject();
          });
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [USER.GET_AT_LIST](state, { status, kw, matches, recents, users }) {
      if (status === 'start') {
        if (state.kwPending !== kw) {
          state.kwPending = kw;
          state.kw = null;
          state.matches = [];
          state.recents = [];
          state.users = [];
        }
      } else if (status === 'success') {
        if (state.kwPending === kw) {
          state.kwPending = null;
          state.kw = kw;
          state.matches = matches || [];
          state.recents = recents || [];
          state.users = users || [];
        }
      } else if (status === 'failure') {
        if (state.kwPending === kw) {
          state.kwPending = null;
        }
      }
    },
  },
};
